import { Alert } from '@/components/ui/Alert'
import { useManagedVenues } from '@/hooks/useManagedVenues'
import { findManagedVenue } from '@/lib/venue/managerVenueTypes'

/**
 * 운영 인증 만료 시 "노출·신규예약 제외" 안내 — 구장 하위 모든 화면에서 공통으로 보인다.
 * `VenueLayout` 이 셸 레벨에서 마운트한다(구 `components/passes/VenueExposureBanner.tsx`를 이동·개서 —
 * 이용권이 아니라 운영 인증 축 기반이다. 설계 §2 자율 결정).
 *
 * 🚨 배너는 접근 제어가 아니라 안내다 — 로딩·조회 실패·미소속 구장이면 조용히 아무것도 보여주지 않는다.
 * 🚨 `useManagedVenues` 는 `VenueLayout`(소속 검사)이 이미 구독 중인 쿼리라 네트워크 요청이 중복되지 않는다.
 */
export function VenueExposureBanner({ venueId }: { venueId: string }) {
  const venuesQuery = useManagedVenues()
  const venue = findManagedVenue(venuesQuery.data, venueId)
  if (!venue || venue.operationVerification.status !== 'EXPIRED') return null

  return (
    <div className="mb-5">
      <Alert tone="danger" title="구장이 사용자에게 노출되지 않습니다">
        운영 인증이 만료되면 구장이 목록·검색에서 제외되고 신규 예약을 받을 수 없습니다. 기존 구장·예약·정산
        데이터는 유지되며 인증을 완료하면 즉시 복원됩니다.
      </Alert>
    </div>
  )
}
